export class storeQuickAccessController {
    MoreItem: boolean;
    AllCategory: any;
    AjaxLoading: boolean;
    PageNumber: number;
    AjaxLoadingMore: boolean;
    history: any;
    BaseUrlPage: any;
    customFullscreen: boolean = false
    constructor(private $window, private $quickAccess, private $mdDialog, private $mPath, private localStorageService, private MyConstant) {
        "ngInject"

    }
    $onInit() {

        this.history = this.localStorageService.get('QuickAccessHistory') || [{
            ID: null,
            TypeID: 1
        }];
        var TypeID = this.history[this.history.length - 1].TypeID;
        var ID = this.history[this.history.length - 1].ID;
        this.getNode(1, TypeID, ID);

        this.$mPath.get().then(response => {
            this.BaseUrlPage = response;
        })

    }

    selectItem(item) {

        if (item.TypeID == 3) {
            var last = this.history.length - 1
            var productTypeID = this.history[last].ID
            this.$window.location.href = this.BaseUrlPage.StoreListByTypeFilter + '/productTypeID/' + productTypeID + '/defID0/' + item.ID + '/'
        }
        else {
            this.history.push({
                ID: item.ID,
                TypeID: item.TypeID,
                Name: item.Name
            })
            this.localStorageService.set('QuickAccessHistory', this.history)
            this.getNode(1, item.TypeID, item.ID);
        }
    }

    seeAll() {
        var last = this.history.length - 1
        var TypeID = this.history[last].TypeID
        var ID = this.history[last].ID
        if (TypeID == 1) {
            this.$window.location.href = this.BaseUrlPage.StoreListByCatFilter + '/catID/' + ID
        }
        else if (TypeID == 2) {
            this.$window.location.href = this.BaseUrlPage.StoreListByTypeFilter + '/productTypeID/' + ID
        }
    }

    back() {
        var last = this.history.length - 1
        this.history.splice(last, 1);
        last = this.history.length - 1
        // 
        //this.history =this.history.slice(0, itemIndex+1);
        this.localStorageService.set('QuickAccessHistory', this.history)
        var TypeID = this.history[last].TypeID;
        var ID = this.history[last].ID;
        this.getNode(1, TypeID, ID);
    }

    hangeBC(item, itemIndex) {
        this.history = this.history.slice(0, itemIndex + 1);
        this.localStorageService.set('QuickAccessHistory', this.history)
        var TypeID = item.TypeID;
        var ID = item.ID;
        this.getNode(1, TypeID, ID);
    }

    openMap(ev, item) {
        this.$mdDialog.show({
            controller: function ShowMapController($scope, $mdDialog, $VendorLoaction, NgMap, BaseUrl, item) {
                "ngInject"
                $scope.BaseUrlPage = BaseUrl;
                $scope.googleMapsUrl = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDqLzkWTDlaVOOjFEnyv-xN_O3Zxw9QKPY"
                $scope.AjaxLoading = true

                $VendorLoaction.List(item.TypeID, item.ID).then(function (data) {
                    $scope.VendorList = data.data;
                    // 
                    // if($scope.VendorList.length === 1){
                    //     $scope.center = "'" + data[0].Latitude + "," + data[0].Longitude + "'";
                    // }
                    // if($scope.VendorList.length > 1){
                    //      $scope.center = "35.6807421,51.413044"
                    // }
                    // 
                    $scope.AjaxLoading = false
                    // 
                })
                NgMap.getMap().then(function (evtMap) {
                    $scope.map = evtMap;
                    var markers = evtMap.markers;
                    var bounds = new google.maps.LatLngBounds();
                    angular.forEach(markers, function (val, key) {
                        bounds.extend(val.position);
                    })
                    $scope.map.fitBounds(bounds);
                    if ($scope.VendorList.length === 1) {

                        $scope.map.setZoom(12);
                    }
                })
                $scope.showDetail = function (e, shop) {
                    $scope.vendorInfo = shop;
                    $scope.map.showInfoWindow('foo-iw', shop.VendorID.toString());
                };
                $scope.hideDetail = function () {
                    $scope.map.hideInfoWindow('foo-iw');
                };
                $scope.hide = function () {
                    $mdDialog.hide();
                };

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.answer = function (answer) {
                    $mdDialog.hide(answer);
                };
            },
            template: `<md-dialog class="vendor-on-map" aria-label="مشاهده فروشندگان روی نقشه" class="full-screen" flex="70">
            <form ng-cloak>
                <md-toolbar>
                <div class="md-toolbar-tools">
                    <h2>مشاهده فروشندگان روی نقشه</h2>
                    <span flex></span>
                    <md-button class="md-icon-button" ng-click="cancel()">
                    <md-icon class="fa fa-times" aria-label="Close dialog"></md-icon>
                    </md-button>
                </div>
                </md-toolbar>

                <md-dialog-content layout="row">
                <div style="min-height:300px">
                    <spn-loading ng-if="AjaxLoading"></spn-loading>
                </div>

                <div style="width: 100%;height: calc(100% - 56px);position: absolute;left:0;bottom:0" ng-if="!AjaxLoading" map-lazy-load="{{googleMapsUrl}}">
                    <ng-map style="width: 100%;height: 100%;" center="{{center}}" zoom="13">
                    <marker icon="{
                                url:'/DesktopModules/ECBMainStore/ECBMainView/img/ic_map_marker_black_36dp.png',
                                scaledSize:[30,30]
                                }" on-click="showDetail(vendor)" id="{{vendor.VendorID}}" ng-repeat="vendor in VendorList" title="{{vendor.Name}}"
                        position="[{{vendor.Latitude}}, {{vendor.Longitude}}]">
                    </marker>
                    <info-window id="foo-iw">
                        <div ng-non-bindable="" style="font-family:ecb;margin-right: 15px;">
                        نام فروشگاه: {{vendorInfo.Name}}<br/> لوگو: <img ng-src="{{vendorInfo.VendorImage}}" style="max-width:80px"
                            alt=""> <br/> نماد: <span ng-if="vendorInfo.HasENamad" style="color:green"><i class="fa fa-check"></i></span>
                        <span
                            ng-if="!vendorInfo.HasENamad" style="color:red"><i class="fa fa-times"></i></span><br/>
                            <a ng-href="{{BaseUrlPage.StoreVendorProductList}}/VendorID/{{vendorInfo.VendorID}}">مشاهده محصولات</a>
                        </div>
                    </info-window>
                    </ng-map>

                </div>
                </md-dialog-content>

                <!--<md-dialog-actions layout="row">
                
                <md-button ng-click="answer('not useful')">
                بستن
                </md-button>
                
                </md-dialog-actions>-->
            </form>
            </md-dialog>`,
            parent: angular.element(document.body),
            targetEvent: ev,
            locals: {
                item: item,
                BaseUrl: this.BaseUrlPage
            },
            clickOutsideToClose: true,
            fullscreen:true
        })

    }
    
    loadMore() {
        this.AjaxLoadingMore = true
        var PageNumber = this.PageNumber + 1
        var last = this.history.length - 1
        var TypeID = this.history[last].TypeID
        var ID = this.history[last].ID
        this.$quickAccess.GetNode(PageNumber, TypeID, ID, 54).then(res => {
            this.AllCategory.push.apply(this.AllCategory, res.data.TreeNodeModelItem)
            this.AjaxLoadingMore = false
            this.PageNumber = res.data.PageNumber
            this.MoreItem = (res.data.PageSize * res.data.PageNumber) < res.data.TotalRow ? true : false
        })
    }

    getNode(PageNumber, TypeID, ID, isPush?) {
        this.AjaxLoading = true;
        this.$quickAccess.GetNode(PageNumber, TypeID, ID).then(res => {
            this.AjaxLoading = false;
            this.AllCategory = res.data.TreeNodeModelItem;
            this.PageNumber = res.data.PageNumber;
            this.MoreItem = (res.data.PageSize * res.data.PageNumber) < res.data.TotalRow ? true : false;
        })
    }
}















// WEBPACK FOOTER //
// ./src/components/store-quick-access/store-quick-access.controller.ts